var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1,1)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image2",
    x: 0,
    y: 0,
    width: "68px",
    height: "68px"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image2",
    width: "68px",
    height: "68px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAErElEQVR4nO2cv3IbVRSHv3OlmMwQy8pkUgQyg1TQhbF4AbBfgDgFdcITOH4C2U9g0tDi8AJxho7GSgMNjJUZGhqizMCkoMh6bZgQa/dHISlIsmRr/1irlf1VslfnztFv7t675+w515gSB29UsSIrzlgWVBA1AIzKwBdFC8MDPINmKJ4rpLm0YM1p+GnnNbAvlQlYc8bnEmsY5UQDCg+jIfGUArslMy8lVwdIXRC/rRVn3JV4kFiEUzDYCQIepT1zUhPEb2vFjDqwktaYE9KQ2CoVrZHGYIkFOXirmiuwzfSFGGY3PGZj6aq1kgwSWxBfKjtYV8hmEgfSxhyb18y2YtvHMfKlioU8ge5OMWuIVthmNc5scVEN/pHuW8A+syoGgFFxRfb9th5GNY0kyJFUD0J2znP3SA2jbMb2kVSPZjYhR1J91taLSYmyrkwkSJ7F6DGpKGcKMg9i9JhElFMF+VtaD0O+TtetjHE8WDR7PO7yWEF8qWIB+7lYQKMgvLDNp+O25LG7jAXszZ0YAEbZXeGJL438bSMFOZLqJ8Ly+aJGwMhnlBO3TPcp9MX5+5Q9YcCnw9HyiRliIdvTcylbukHpAAMzpBvC703PpeyRWO1PHQzMkG4+40Ix/JvfzZBuXmN/+i5lT/8sKfb+WSiwrpgD/uUf8d1Pv/DK99PwLzaffVzli9qdOKZrQAO6M8SXyhbyOq4jW9//wN5vv8c1T5Vv739J9eaNaEbCU4FqyczrrCEBa0mcqN3+IIl5apSuLnDtvYXohkZZxx0NDOCwrSdYMlF+/eNVEvNUqN68wftxBAEEO6WCfdUT5PVcPqZHQXiLRbvuDt6qduHFADDKb6SPnLkZzo1OmX+PWXXMcrJ4ypij5sxYztqRGaLi0OX60cNg2cGlIP3YYaC4T+xzSfHsr5zNHMQy70hFkG+e/TgTsczPL//kkw9vRY9l+oj8bncUuY9l+rDDtl6kkVDOeywDgGilcssA3Ll9K62hssPwHDCV6r48IOE5wcusHZkhnl/OkEGajkInl3gJKKR5mSDq0UsQdT7zNGt/skbwDP5/MGtk58rMsAv9ryECXsS9beYhlpHjesnMKwKUzDy/rccG63EGy3ssI9jpNRP0xzK7cR3JeyyjgEe9zwNv/w8D7RGzZj2vsYxEo1S01d7fl+UQp5VDdC80uCBI7A63lZwoqbpIZRHhMdXhasQTCaKlBWtKxG6vyAsSW6NKM0fWqXbLI/aY15dYorVYtOqoSyNTiCUzT457iHNp9MuUTuHu6rjLY3OqJbOWYON8vMqOcMyt0uPUJHOpaDvztJ5IbC1dsVNr9ydqD/Hb2sx7hWK3c3PzrO9N3ECUZ1EmFQMiNiHmUZQoYkCMrsyDYz10Rn3mM2zCE2yUirYTxSx+m2qnfaQSx34KNMNj7k2lTRU6W/Ji0aqzuANJbMnF69mFFFrdfalCwLYlLOtMikRDIRtJD0dI9TAEoG423TMAJBowQ4chDHPwVjVzPDTjftpjv6OzYD6Gk+F7Us79QBXgrsFKGgeqyNhFPMvVgSrj6M6cGp0IeplObVvZhnYqiVb3Y5POe+em2jSSHoMxKf8BGpfc2MSYoI8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.33e54a152618e58e7e852121d1bac430.svg";
export { ForwardRef as ReactComponent };